import React from "react";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import Table from "../../Common/Table";
import TableFields from "../../../constants/AvailableSlots/TableFields.json";
import DeliveryPartnerBlankState from "../../DeliveryDrivers/DeliveryPartnerBlankState";
import { connect } from "react-redux";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { isValNull } from "../../../utils";

const SlotsList = ({ availableSlotslist }) => {
  const history = useHistory();

  const handleRowClick = (capacity_id) => {
    history.push(`/slots-details/${capacity_id}`);
  };

  const getBookingPercentage = (slot) => {
    return (
      Math.round(
        (((slot.total_capacity - slot.available_capacity) /
          slot.total_capacity) *
          100 +
          Number.EPSILON) *
          100
      ) /
        100 +
      "%"
    );
  };

  const getFieldValue = (item, key) => {
    if (key.includes("time") && !isValNull(item[key])) {
      return moment(item[key]).format("h:mm A");
    } else if (key.includes("capacity_id") && !isValNull(item[key])) {
      return (
        <span
          onClick={() => handleRowClick(item[key])}
          className="edit-options"
        >
          {item[key]}
        </span>
      );
    } else if (key === "available_capacity") {
      return !isValNull(item[key])
        ? item[key] + " (" + getBookingPercentage(item) + " booked)"
        : "0 (100% booked)";
    } else if (key.includes("capacity")) {
      return !isValNull(item[key]) ? item[key] : "0";
    } else if (key.includes("percentage") && !isValNull(item[key])) {
      return Math.round((item[key] + Number.EPSILON) * 100) / 100 + "%";
    }
    return !isValNull(item[key]) ? item[key] : "NA";
  };

  const sortListOnStartTime = (list) => {
    const newList = list.sort(function (a, b) {
      return new Date(a.slot_start_time) - new Date(b.slot_start_time);
    });
    return newList;
  };

  return (
    <SlotsListHolder>
      {availableSlotslist.length > 0 ? (
        <Table
          fontSize="0.75rem"
          list={sortListOnStartTime(availableSlotslist)}
          fields={TableFields}
          getFieldValue={getFieldValue}
        />
      ) : (
        <DeliveryPartnerBlankState />
      )}
    </SlotsListHolder>
  );
};

const SlotsListHolder = styled.div`
  background: ${variables.white};
  border: 0.5px solid ${variables.grey300};
  box-sizing: border-box;
  border-radius: 8px;
  height: calc(100vh - 200px);
  width: 100%;
`;

function mapStateToProps(state) {
  const { Slots } = state;
  return {
    availableSlotslist: Slots.slotsList,
  };
}

export default connect(mapStateToProps, null)(SlotsList);
